import React, { useState } from "react";
import { useEffect } from 'react';
import apiService from "../../service/apiService";
import { Autocomplete, FormControlLabel, Switch } from '@mui/material';
import { useNavigate } from "react-router-dom";


import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    Paper,
    Container,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from "@mui/material";




const AddTlOutreach = () => {
    const [producerGroups, setProducerGroups] = useState([]);
    const navigate = useNavigate(); // Hook for navigation
    const [seasonList, setSeasonList] = useState([]);
    const [seedClasses, setSeedClasses] = useState([]);
    const [seedClassList, setSeedClassList] = useState([]);
    const [seedList, setSeedList] = useState([]);
    const [varietyList, setVarietyList] = useState([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [updatedBy, setUpdatedBy] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const [rows, setRows] = useState([]);
    const [seedData, setSeedData] = useState(null);
    const [farmersList, setFarmersList] = useState([]);
    const [producingFarmerId, setProducingFarmerId] = useState('');
    const [receivingFarmerId, setReceivingFarmerId] = useState('');
    const [marketLinkageId, setMarketLinkageId] = useState('');
    const [farmerName, setFarmerName] = useState('');
    const [address, setAddress] = useState('');
    const [areaCoverage, setAreaCoverage] = useState('');
    const [remarks, setRemarks] = useState('');
    const [unit, setUnit] = useState('');
    const [seasons, setSeasons] = useState([]);
    const [years, setYears] = useState([]);
    const [planmasterid, setPlanMasterid] = useState("");
    const [seasonId, setSeasonId] = useState("");
    const [yearId, setYearId] = useState("");
    const [marketLinkageOptions, setMarketLinkageOptions] = useState([]);
    const [selectedMarketLinkageId, setSelectedMarketLinkageId] = useState(null);
    const [availableseed, setAvailableseed] = useState(0);
    const [isKg, setIsKg] = useState(false);



    // Function to handle the toggle change
    const handleToggleChange = (event) => {
        setIsKg(event.target.checked);
        setDisbursedTLQuantity("");
    };


    const [disbursedTLQuantity, setDisbursedTLQuantity] = useState(0);
    const handleDisbursedQuantityChange = (event) => {
        const value = event.target.value;


        const isValidInput = /^(\d+(\.\d{0,3})?)?$/.test(value);

        if (isValidInput) {
            const numericValue = parseFloat(value) || 0;
            if (numericValue <= convertedValue) {
                setDisbursedTLQuantity(value);
            } else {
                setDisbursedTLQuantity(convertedValue.toFixed(2));
            }
        }
    };
    const availableTLSeed = marketLinkageOptions.find(option => option.value === selectedMarketLinkageId)?.availableTLSeed || 0;
    console.log("availableseed from respponse", availableTLSeed);
    const convertedValue = isKg ? availableTLSeed * 100 : availableTLSeed;
    console.log("convert from respponse", convertedValue);
    const remainingValue = Math.max(0, parseFloat((convertedValue - disbursedTLQuantity).toFixed(3)));
    console.log("remaining from respponse", remainingValue);
    const [casteList, setCasteList] = useState([]); 
    useEffect(() => {
        apiService
            .get('/producer-groups/get-all')
            .then((response) => {
                setProducerGroups(response.data);
            })
            .catch((error) => {
                console.error('Error fetching producer groups:', error);
            });

        apiService
            .get('/farmers/get-all')
            .then((response) => {
                setFarmersList(response.data);
            })
            .catch((error) => {
                console.error('Error fetching farmers data:', error);
            });

        apiService
            .get("/seasons/get-all")
            .then((response) => {
                setSeasons(response.data);
            })
            .catch((error) => {
                console.error("Error fetching seasons data:", error);
            });
        apiService
            .get("/years/get-all")
            .then((response) => {
                setYears(response.data);
            })
            .catch((error) => {
                console.error("Error fetching years data:", error);
            });
    }, []);


    const handleFarmerChange = (event, newValue) => {
        setFormData((prevState) => ({
            ...prevState,
            receivingFarmerId: newValue ? newValue.farmerId : '',
            ReceiverFramer: newValue ? '' : prevState.ReceiverFramer,
        }));
    };

    const fetchMarketLinkageId = async () => {
        apiService
            .get(
                `/tl-outreach/get-tl-seed-by-crop-plan-master/${planmasterid}?seasonId=${seasonId}&yearId=${yearId}`
            )
            .then((response) => {
                const seedData = response.data.body;
                console.log("seeddata is", seedData);
                if (seedData && seedData.length > 0) {
                    const options = seedData.map((item) => ({
                        label: item.seedName, // Customize label as needed
                        value: item.marketLinkageId,
                        availableTLSeed: item.availableTLSeed,
                        seedVarietyName: item.seedVarietyName,
                    }));
                    setMarketLinkageOptions(options);
                    setAvailableseed(options[0]?.availableTLSeed || null)

                    setSelectedMarketLinkageId(options[0]?.value || null);
                }
            })
            .catch((error) => {
                console.error(
                    "Error fetching seed data by crop plan master:",
                    error
                );
            });
    };
    const handleMarketLinkageChange = (event) => {
        setSelectedMarketLinkageId(event.target.value);
    };

    useEffect(() => {
        if (planmasterid && seasonId && yearId) {
            fetchMarketLinkageId();
        }


    }, [planmasterid, seasonId, yearId]);



    // useEffect(() => {
    //     if (planmasterid && seasonId && yearId) {
    //         fetchMarketLinkageid();
    //     }
    // }, [planmasterid, seasonId, yearId]);

    const handleChange = (event, newValue) => {
        if (newValue && newValue.producerGroupId) {
            apiService
                .get(`/tl-outreach/get-tl-seed-by-pg/${newValue.producerGroupId}`)
                .then((response) => {
                    const farmerDataList = response.data.body;

                    if (farmerDataList && farmerDataList.length > 0) {
                        setPlanMasterid(farmerDataList[0].cropPlanMasterId);
                        // Update formData to include all farmer options and the first selected farmer
                        setFormData((prevState) => ({
                            ...prevState,
                            Producing: newValue,
                            farmerOptions: farmerDataList, // Store the full list of farmers
                            farmerName: farmerDataList[0].farmerName, // Default selection
                            producingFarmerId: farmerDataList[0].producingFarmerId,
                            marketLinkageId: farmerDataList[0].marketLinkageId,
                        }));
                    } else {
                        setFormData((prevState) => ({
                            ...prevState,
                            farmerOptions: [], 
                            farmerName: '', 
                            producingFarmerId: '', 
                            marketLinkageId: '', 
                            Producing: newValue,
                        }));
                    }

                })
                .catch((error) => {
                    console.error('Error fetching seed data:', error);
                    setFormData((prevState) => ({
                    ...prevState,
                    farmerOptions: [],
                    farmerName: '',
                    producingFarmerId: '',
                    marketLinkageId: '',
                    Producing: newValue,
                }));
                });
        }
    };


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            ...(name === "ReceiverFramer" && { farmerName: value }) // Map ReceiverFramer to farmerName
        }));
    };
    
    const [formData, setFormData] = useState({
        producingFarmerId: "",
        farmerName: "",
        ReceiverFramer: "",
        address: "",
        areacoverage: "",
        remarks: "",
        receivingFarmerId: "",
        marketLinkageId: "",
        disbursedTLQuantity: "",
        unit: "", Producing: null,

    });


    const handleCancel = () => {
        navigate(-1);
    };
    const handleSubmit = async () => {
        const isConfirmed = window.confirm("Are you sure you want to add this TL INFO?");
    
        if (!isConfirmed) {
            return; // Exit if user cancels
        }
    
        // Determine unit based on toggle state
        const unitValue = isKg ? 2 : 1; // 2 for kg, 1 for qtl
    
        // Use the value entered by the user for `disbursedTLQuantity`
        const disbursedQuantity = parseFloat(disbursedTLQuantity) || 0;
    
        // Prepare the simplified payload
        const payload = {
            producingFarmerId: formData.producingFarmerId,
            marketLinkageId: selectedMarketLinkageId,
            disbursedTLQuantity: disbursedQuantity, // Use the user's input
            areaCoverage: Number(formData.areacoverage),
            remarks: formData.remarks || "", // Fallback to an empty string
            unit: unitValue, // Add unit dynamically
        };
    
        // Add fields conditionally
        if (formData.receivingFarmerId) {
            payload.receivingFarmerId = formData.receivingFarmerId;
        } else {
            payload.farmerName = formData.ReceiverFramer || ""; // Use the user input
            payload.address = formData.address || ""; // Fallback to empty
        }
    
        try {
            const response = await apiService.post('/tl-outreach/create-child', payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            console.log('Response:', response.data);
            alert('Data submitted successfully!');
            navigate(-1);
        } catch (error) {
            console.error('Error submitting data:', error);
            alert('An error occurred while submitting the data.');
        }
    };
    





    // Handles quantity input change
    const handleDisbursedTLQuantityChange = (e) => {
        const inputValue = e.target.value;
        const availableTLSeed = marketLinkageOptions.find(
            (option) => option.value === selectedMarketLinkageId
        )?.availableTLSeed;

        const convertedValue = unit === 'kg' ? inputValue : inputValue * 100;

        if (convertedValue > availableTLSeed) {
            alert("Disbursed TL Quantity cannot be greater than Available TL Seed");
            return;
        }

        setFormData((prevData) => ({
            ...prevData,
            disbursedTLQuantity: convertedValue,
        }));
    };

    // Handles toggle between kg and qtl
    const handleUnitToggle = (isQtlSelected) => {
        setUnit(isQtlSelected ? 'qtl' : 'kg');

        setFormData((prevData) => ({
            ...prevData,
            disbursedTLQuantity: isQtlSelected
                ? prevData.disbursedTLQuantity / 100 // Convert kg to qtl
                : prevData.disbursedTLQuantity * 100, // Convert qtl to kg
        }));
    };


    return (
        <Paper
            elevation={4}
            sx={{
                padding: 4,
                borderRadius: 0,
                height: "92vh",
                overflowY: "auto",
            }}
        >
            <Typography
                variant="h3"
                gutterBottom
                align="center"
                sx={{
                    color: "#1976d2",
                    fontWeight: "bold",
                }}
            >
                Add Tl-Outreach
            </Typography>

            <Grid container spacing={3}>
                {/* Producer Section */}
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                        <h4>Producer Section</h4>
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                    style={{marginTop:"0px"}}
                    value={formData.Producing}
                    options={producerGroups}
                    getOptionLabel={(option) => option.pgname || ""}
                    onChange={handleChange}
                    filterOptions={(options, { inputValue }) =>
                    options.filter((option) =>
                        option.pgname.toLowerCase().includes(inputValue.toLowerCase())
                    )
                    }
                    renderOption={(props, option) => (
                    <li {...props} key={option.producerGroupId}>
                        {option.pgname}
                    </li>
                    )}
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select Producer Group"
                        variant="outlined"
                        margin="dense"
                        style={{marginTop:"0px"}}
                        fullWidth
                    />
                    )}
                    isOptionEqualToValue={(option, value) =>
                    option.producerGroupId === value.producerGroupId
                    }
                />
    
</Grid>


                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" required>
                        <InputLabel id="farmer-name-label">Farmer Name</InputLabel>
                        <Select
                            labelId="farmer-name-label"
                            id="farmer-name-select"
                            value={formData.farmerName}
                            onChange={(e) => {
                                const selectedFarmer = formData.farmerOptions.find(
                                    (farmer) => farmer.farmerName === e.target.value
                                );
                                setFormData((prevState) => ({
                                    ...prevState,
                                    farmerName: selectedFarmer.farmerName,
                                    producingFarmerId: selectedFarmer.producingFarmerId,
                                    marketLinkageId: selectedFarmer.marketLinkageId,
                                }));
                            }}
                            label="Farmer Name"
                        >
                            {formData.farmerOptions &&
                                formData.farmerOptions.map((farmer, index) => (
                                    <MenuItem key={index} value={farmer.farmerName}>
                                        {farmer.farmerName}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" required>
                        <InputLabel id="season-select-label">Season</InputLabel>
                        <Select
                            labelId="season-select-label"
                            id="season-select"
                            value={seasonId}
                            onChange={(event) => setSeasonId(event.target.value)}
                            label="Season"
                        >
                            {seasons.map((season) => (
                                <MenuItem key={season.seasonId} value={season.seasonId}>
                                    {season.seasonName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" required>
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                            labelId="year-select-label"
                            id="year-select"
                            value={yearId}
                            onChange={(event) => setYearId(event.target.value)}
                            label="Year"
                        >
                            {years.map((year) => (
                                <MenuItem key={year.yearId} value={year.yearId}>
                                    {year.yearValue}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" required>
                        <InputLabel id="marketLinkage-label">Crop</InputLabel>
                        <Select
                            labelId="marketLinkage-label"
                            id="marketLinkage"
                            value={selectedMarketLinkageId || ""}
                            onChange={handleMarketLinkageChange}
                        >
                            {marketLinkageOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Display Available TL Seed */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={`Available TL Seed (${isKg ? 'kg' : 'qtl'})`}
                        name="availableTLSeed"
                        value={remainingValue || 0}
                        variant="outlined"
                        disabled
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isKg}
                                onChange={handleToggleChange}
                                name="qtlKgToggle"
                                color="primary"
                            />
                        }
                        label={isKg ? "Show in kg" : "Show in qtl"}
                    />
                </Grid>

                {/* Toggle Switch for qtl/kg */}
                {/* <Grid item xs={12} sm={6}>
        <FormControlLabel
            control={
                <Switch
                    checked={isKg}
                    onChange={handleToggleChange}
                    name="qtlKgToggle"
                    color="primary"
                />
            }
            label={isKg ? "Show in kg" : "Show in qtl"}
        />
    </Grid> */}

                {/* Displaying Seed Variety Name */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Crop Variety Name"
                        name="seedVarietyName"
                        value={
                            marketLinkageOptions.find(
                                (option) => option.value === selectedMarketLinkageId
                            )?.seedVarietyName || ""
                        }
                        variant="outlined"
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <TextField
                            fullWidth
                            label="Sold/Exchange/Share Quantity"
                            name="disbursedTLQuantity"
                            variant="outlined"
                            type="number"
                            value={disbursedTLQuantity}
                            onChange={handleDisbursedQuantityChange}
                        />
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Remarks"
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleInputChange}
                        variant="outlined"
                        multiline
                        rows={3}
                    />
                </Grid>

                {/* Receiver Section */}
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                        <h4>Receiver Section</h4>
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        options={farmersList}
                        getOptionLabel={(option) => option.farmerName}
                        isOptionEqualToValue={(option, value) => option.farmerId === value.farmerId}
                        onChange={handleFarmerChange}
                        disabled={!!formData.ReceiverFramer}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Receiving Farmer under PG"
                                variant="outlined"
                                required
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
    <TextField
        fullWidth
        label="Receiver Farmer"
        name="ReceiverFramer"
        value={formData.ReceiverFramer || ""}
        onChange={handleInputChange}
        variant="outlined"
        disabled={!!formData.receivingFarmerId}
    />
</Grid>


                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Address"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        variant="outlined"
                        disabled={!!formData.receivingFarmerId} // Disable if receivingFarmerId is present
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Area Coverage"
                        name="areacoverage"
                        value={formData.areacoverage}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                                handleInputChange(e);
                            }
                        }}
                        variant="outlined"
                        type="text"
                    />
                </Grid>

                {/* Action Buttons */}
                <Grid item xs={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                            mt: 3,
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '14px',
                                paddingX: 3,
                                paddingY: 0.5,
                                height: '40px',
                                borderRadius: '20px',
                                backgroundColor: '#1976d2',
                                '&:hover': {
                                    backgroundColor: '#115293',
                                    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.2)',
                                },
                                transition: 'all 0.3s ease-in-out',
                            }}
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleCancel}
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '14px',
                                paddingX: 3,
                                paddingY: 0.5,
                                height: '40px',
                                borderRadius: '20px',
                                borderColor: '#f50057',
                                color: '#f50057',
                                '&:hover': {
                                    backgroundColor: '#ffe3ea',
                                    borderColor: '#c51162',
                                    color: '#c51162',
                                },
                                transition: 'all 0.3s ease-in-out',
                            }}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Grid>
            </Grid>



        </Paper >
    );
};

export default AddTlOutreach

